module.exports = __webpack_public_path__ + "media/images/search-2ae006271985b13ffcb3b8328ddb5ae8.svg";